import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $stretch?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px;
  min-width: 140px;
  max-width: 220px;
  border: 0;
  border-radius: 999px;
  transition: background ${({ theme: { motion } }) => motion?.duration?.fast ?? '120ms'}
    ${({ theme: { motion } }) => motion?.easing?.standard ?? 'cubic-bezier(0.2,0,0,1)'};

  ${({ theme: { colors = {} } }) => css`
    background: color-mix(in oklch, ${colors.onSurface ?? '#E4E1ED'} 5%, transparent);
    color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
    &:focus-within {
      background: color-mix(in oklch, ${colors.onSurface ?? '#E4E1ED'} 8%, transparent);
    }
  `}

  ${({ $stretch }) =>
    $stretch &&
    css`
      max-width: none;
      width: 100%;
      flex: 1;
    `}
`;

export const LeadingSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0.55;
  & > svg,
  & > .material-symbols-rounded {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  background: transparent;
  border: 0;
  outline: none;
  padding: 0;
  font: inherit;
  font-size: 13px;
  appearance: none;
  -webkit-appearance: none;

  /*
   * Suppress every browser-injected affordance for \`type="search"\` so our
   * own \`<ClearButton>\` is the only X in the field. WebKit injects a blue
   * cancel glyph by default; some Chromium builds also inject a search-icon
   * decoration on the leading edge.
   */
  &::-webkit-search-cancel-button,
  &::-webkit-search-decoration,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    -webkit-appearance: none;
    appearance: none;
    display: none;
  }

  /* IE / legacy Edge clear "x" */
  &::-ms-clear,
  &::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurface ?? '#E4E1ED'};
    &::placeholder {
      color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
    }
  `}
`;

export const ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  padding: 0;
  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
    &:hover {
      background: color-mix(in oklch, ${colors.onSurface ?? '#E4E1ED'} 10%, transparent);
      color: ${colors.onSurface ?? '#E4E1ED'};
    }
  `}
  & > svg,
  & > .material-symbols-rounded {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
`;
